import {FC} from 'react'
import { formatVerificationChecksKyb } from '../../../../../../../utils/streamlineSpecificHelpers';

type Props = {
  check?: string
}
const VerificationCheck: FC<Props> = ({check}) => (
  <span className='badge py-2 px-4 fs-8 badge-light-dark'>{formatVerificationChecksKyb(check || '')?.title}</span>
)
export {VerificationCheck}